import {makeStyles} from '@material-ui/core';
import React from 'react';
import {getFriendlyTeamName} from '../../../utils/gameUtils';
import {TeamImage} from '../../odds/TeamImage';


const teamEventStyles = makeStyles({
    container: {
        zIndex: 5,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '90%',
        flexGrow: 0,
        flexShrink: 0,
        flexBasis: '40px',
        "& p": {
            color: 'black',
            margin: 0,
            overflow: 'none',
        },
    },
    teamImage: {
        width: 42,
        height: 42,
        objectFit: 'contain',
    },
    teamName: {
        fontWeight: 600,
        fontSize: 14,
    },
    teamNameDiv: {
        height: 26,
    }
});
export const TeamEventHeader = ({competitor, league}) => {
    const classes = teamEventStyles();
    return (
        <div className={classes.container}>
            <TeamImage className={classes.teamImage} competitor={competitor} league={league}/>
            <div className={classes.teamNameDiv}>
                <p className={classes.teamName}>
                    {getFriendlyTeamName(league, competitor)}
                </p>
            </div>
        </div>
    )
}